import o from "./highrise642.mjs";
const n = "@@ziContext", c = {
  mounted(e, t) {
    const { value: d = {} } = t, { zIndex: i, enabled: a } = d;
    e[n] = {
      enabled: !!a,
      initialized: !1
    }, a && (o.ensureZIndex(e, i), e[n].initialized = !0);
  },
  updated(e, t) {
    const { value: d = {} } = t, { zIndex: i, enabled: a } = d, s = e[n].enabled;
    a && !s && (o.ensureZIndex(e, i), e[n].initialized = !0), e[n].enabled = !!a;
  },
  unmounted(e, t) {
    if (!e[n].initialized)
      return;
    const { value: d = {} } = t, { zIndex: i } = d;
    o.unregister(e, i);
  }
};
export {
  c as default
};
